import React from "react";
import { useNavigate } from "react-router-dom";
import "./TestInfoPage.css";
import search from "../../../assets/search.png";
import FakeNavigation from "../../../components/FakeNav/FakeNav";

const TestInfoPage: React.FC = () => {
  const navigate = useNavigate();

  const handleStartTest = () => {
    localStorage.removeItem("testQuestions");
    localStorage.removeItem("answers");
    localStorage.removeItem("currentQuestion");
    localStorage.removeItem("timeLeft");
    localStorage.removeItem("startTime");
    localStorage.removeItem("endTime");
    localStorage.removeItem("testAttemptId");
    navigate("/test");
  };

  return (
    <div role="main" className="wrapper">
      <div className="title"></div>
      <div className="title22">
        <div>Тестирование - 1 -й этап</div>
        <div className="imgCont">
          <img src={search} alt="" style={{ width: 20 }} />
        </div>
      </div>
      <div className="container">
        <div className="content">
          <div
            onClick={() => {
              localStorage.clear();

              navigate("/");
            }}
            className="gohome"
          >
            Выход
          </div>
          <div></div>
          <h2>Тестирование</h2>
          <div className="box quizinfo">
            <p>Ограничение по времени: 1 ч.</p>
            <p>Метод оценивания: Последняя попытка</p>
          </div>
          <h3>Результаты ваших предыдущих попыток</h3>
          <table className="generaltable quizattemptsummary">
            <thead>
              <tr>
                <th
                  className="header c0"
                  style={{ textAlign: "center" }}
                  scope="col"
                >
                  Попытка
                </th>
                <th
                  className="header c1"
                  style={{ textAlign: "left" }}
                  scope="col"
                >
                  Состояние
                </th>
                <th
                  className="header c2 lastcol"
                  style={{ textAlign: "center" }}
                  scope="col"
                >
                  Просмотр
                </th>
              </tr>
            </thead>
            <tbody></tbody>
          </table>

          <div className="btn-cont">
            <button className="button" onClick={handleStartTest}>
              Пройти тест
            </button>
          </div>
        </div>
        <FakeNavigation />
      </div>
    </div>
  );
};

export default TestInfoPage;
